module.exports = __webpack_public_path__ + "img/image 36.13ce2935.svg";